import {
  ADD_RISK_ASSESSMENT_FILE_FAIL,
  ADD_RISK_ASSESSMENT_FILE_SUCCESS,
  GET_RISK_ASSESSMENT_LIST_FAIL,
  GET_RISK_ASSESSMENT_LIST_SUCCESS,
  DELETE_RISK_ASSESSMENT_FILE_FAIL,
  DELETE_RISK_ASSESSMENT_FILE_SUCCESS,
  UPDATE_STATUS_FAIL,
  UPDATE_STATUS_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  list: [],
  res: [],
  statusRes: [],
  error: [],
  deleteRes: [],
  pagination: {
    page: 1,
    limit: 20,
    total: 0,
    total_pages: 0,
  },
};

const RiskAssessment = (state = INIT_STATE, action) => {
  switch (action.type) {
    case UPDATE_STATUS_SUCCESS:
      return {
        ...state,
        statusRes: action.payload,
      };
    case UPDATE_STATUS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case DELETE_RISK_ASSESSMENT_FILE_SUCCESS:
      return {
        ...state,
        deleteRes: action.payload,
      };
    case DELETE_RISK_ASSESSMENT_FILE_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_RISK_ASSESSMENT_LIST_SUCCESS:
      return {
        ...state,
        list: action.payload?.risk_assessment_records || [],
        pagination: {
          page: action.payload?.pagination?.page || 1,
          limit: action.payload?.pagination?.limit || 20,
          total_pages: action.payload?.pagination?.total_pages || 0,
          total: action.payload?.pagination?.total || 0,
        },
      };

    case GET_RISK_ASSESSMENT_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case ADD_RISK_ASSESSMENT_FILE_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case ADD_RISK_ASSESSMENT_FILE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default RiskAssessment;
